
export function flattenRelatorioCategoriasTree<T extends {items: T[]}>(
  items: T[],
  nivel = 0
) {
  let _items: (T & { nivel: number })[] = [];

  items.forEach((item) => {
    _items.push({ ...item, nivel });

    const children = flattenRelatorioCategoriasTree(item.items, nivel + 1);

    _items.push(...children);
  });

  return _items;
}